/**
 * Inline Stock Indicator
 * Mirrors inventory data from [data-inventory-notice] into the
 * inline #pdp-inline-stock span next to the size label.
 *
 * IMPORTANT: Only observes the notice element's own attributes.
 * Does NOT observe parent/subtree — that causes infinite loops
 * since the inline span lives in the same product info container.
 */
(function () {
  'use strict';

  var lastQty = null;
  var lastHidden = null;

  function update() {
    try {
      var notice = document.querySelector('[data-inventory-notice]');
      var inline = document.getElementById('pdp-inline-stock');
      if (!inline) return;

      if (!notice) {
        inline.style.display = 'none';
        return;
      }

      var qty = parseInt(notice.getAttribute('data-inventory-quantity'), 10);
      var threshold = parseInt(notice.getAttribute('data-inventory-threshold'), 10);
      var isHidden = notice.classList.contains('hidden');

      /* Skip DOM write if nothing changed — prevents any possible re-trigger */
      if (qty === lastQty && isHidden === lastHidden) return;
      lastQty = qty;
      lastHidden = isHidden;

      if (isHidden || isNaN(qty) || qty > threshold || qty <= 0) {
        inline.style.display = 'none';
        inline.textContent = '';
        return;
      }

      inline.style.display = '';
      var dotClass = 'pdp-inline-stock__dot';
      if (qty <= 2) dotClass += ' pdp-inline-stock__dot--critical';
      inline.innerHTML =
        '<span class="' + dotClass + '"></span>' +
        'Only ' + qty + ' left';
    } catch (e) {
      /* Fail silently — never freeze the page */
    }
  }

  function init() {
    lastQty = null;
    lastHidden = null;
    update();

    /* Only observe the notice element's own attributes — never parent/subtree */
    var notice = document.querySelector('[data-inventory-notice]');
    if (notice) {
      new MutationObserver(function () {
        setTimeout(update, 0);
      }).observe(notice, {
        attributes: true,
        attributeFilter: ['data-inventory-quantity', 'class']
      });
    }

    /* Variant change via Shopify PubSub */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        lastQty = null;
        lastHidden = null;
        setTimeout(update, 200);
        setTimeout(update, 600);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 150);
  });
})();
